export default __webpack_public_path__ + "static/media/davinta_white_logo.1b8009a6.svg";